<div class="container">
    <h2 mat-dialog-title>Save Exercise</h2>
    <mat-dialog-content *ngIf="!progressBar">
        <p>Save changes to exercise?</p>
        <p>Your changes will be synced to the database.</p>
    </mat-dialog-content>
    <mat-dialog-content *ngIf="progressBar && !saveFinished && !saveError">
        <p>Saving changes to server...</p>
    </mat-dialog-content>
    <mat-dialog-content *ngIf="saveFinished">
        <p>Successfully saved changes to the server.</p>
    </mat-dialog-content>
    <mat-dialog-content *ngIf="saveError">
        <p>Error saving changes to server.</p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <div fxFlex fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="8px">
        <mat-progress-bar *ngIf="progressBar" class="progress" [mode]="mode" [value]="progress"></mat-progress-bar>
        <div fxFlex fxLayout="row" fxLayoutAlign="center end" fxLayoutGap="8px">
            <button mat-raised-button (click)="cancel()" [disabled]="progressBar">Cancel</button>
            <button *ngIf="!progressBar && !saveError" mat-raised-button color="primary" (click)="submit()">Save</button>
            <button *ngIf="progressBar && !saveError" mat-raised-button color="primary" (click)="close()" [disabled]="!saveFinished">Close</button>
            <button *ngIf="saveError" mat-raised-button color="error" (click)="cancel()">Close</button>
        </div>
    </div>
    </mat-dialog-actions>
</div>
